import cx from 'classnames'
import { ReactNode } from 'react'
import Styles from './TypeSelection.module.scss'

interface Props {
  isFocusVisible: boolean
  isSelected: boolean
  isHovered: boolean
  icon: ReactNode
  title: string
  description: string
}

export const RadioOption = ({ isFocusVisible, isHovered, isSelected, icon, title, description }: Props) => (
  <div
    className={cx(Styles.radioInner, {
      [Styles.selected]: isSelected,
      [Styles.focused]: isFocusVisible,
      [Styles.hovered]: isHovered,
    })}
  >
    {icon}
    <div className={Styles.flex}>
      <div className={Styles.radioTitle}>{title}</div>
      <div className={Styles.radioDescription}>{description}</div>
    </div>
  </div>
)
